import * as Sentry from '@sentry/vue'

const CONSOLE_METHODS = {
  fatal: 'error',
  error: 'error',
  warning: 'warn',
  info: 'info',
  debug: 'debug',
  log: 'log',
}

export function captureMessage(message, { level = 'warning', extra, tags } = {}) {
  const consoleMethod = CONSOLE_METHODS[level] || 'warn'
  console[consoleMethod](`[Sentry ${level}]`, message, extra || '')

  Sentry.captureMessage(message, { level, extra, tags })
}

export function captureException(error, { extra, tags, level } = {}) {
  console.error('[Sentry exception]', error, extra || '', tags || '')

  Sentry.captureException(error, { extra, tags, level })
}

export function addBreadcrumb(breadcrumb) {
  if (typeof Sentry?.addBreadcrumb !== 'function') {
    console.info('[Sentry breadcrumb skipped]', breadcrumb?.message || '', breadcrumb?.data || '')
    return
  }

  console.log(breadcrumb)

  Sentry.addBreadcrumb(breadcrumb)
}
